// extracted by mini-css-extract-plugin
export default {"header":"index_header_maeXq","header_bar":"index_header_bar_mA-7D clearfix","box":"index_box_u-kum","user":"index_user_6UiQc","search":"index_search_5teus"};